const legacy = {
  state: {
    useSafeNumber: false,

    mobileNumber: '',
    shopId: 0,
    showPaymentMethod: false,
    products: [],
    delivery: {
      address: '',
      detailAddress: null,
      memo: '',
      phone: '',
      roadAddress: null
    },
    deliveryFeeDetail: {},
    payment: {
      totalPaymentPrice: 0,
      orderPrice: 0,
      deliveryFee: 0,
      checkedMethodName: 'CREDIT_CARD',
      checkedMethodDescription: '신용/체크카드'
    },
    availablePaymentMethods: {
      primaryMethodTypes: [
        {
          methodName: 'BAEMINPAY_CARD',
          label: 'simplePay',
          description: '배민페이',
          use: true,
          primary: true
        }
      ],
      subMethodTypes: []
    },
    memberCertification: {
      needsCertification: false,
      certificationUrl: ''
    }
  },
  mutations: {
    updateUseSafeNumber: (state, useSafeNumber) => {
      state.useSafeNumber = useSafeNumber
    },

    setProducts: (state, products) => {
      state.products = products
    },
    setShopId: (state, id) => {
      state.shopId = id
    },
    setMobileNumber: (state, mobile) => {
      state.mobileNumber = mobile
    },
    setDeliveryMemo: (state, memo) => {
      state.delivery = {
        ...state.delivery,
        memo
      }
    },
    setPaymentPrice: (state, paymentPrice) => {
      state.payment = {
        ...state.payment,
        totalPaymentPrice: paymentPrice.totalPaymentPrice,
        orderPrice: paymentPrice.orderPrice,
        deliveryFee: paymentPrice.deliveryFee
      }
    },
    setShowPaymentMethod: (state, bool) => {
      state.showPaymentMethod = bool
    },
    setCheckedPaymentMethod: (state, method) => {
      state.payment = {
        ...state.payment,
        checkedMethodName: method.methodName,
        checkedMethodDescription: method.description
      }
    },
    setAvailablePaymentMethods: (state, methods) => {
      state.availablePaymentMethods = methods
    },
    setTotalPaymentPrice: (state, price) => {
      state.payment = { ...state.payment, totalPaymentPrice: price }
    },
    setDelivery: (state, delivery) => {
      state.delivery = {
        ...state.delivery,
        address: delivery.address
      }
    },
    setDeliveryDetail: (state, delivery) => {
      state.delivery = {
        ...state.delivery,
        detailAddress: delivery.detailAddress,
        roadAddress: delivery.roadAddress
      }
    },
    setDeliveryFeeDetail: (state, detail) => {
      state.deliveryFeeDetail = detail
    },
    setDeliveryDetailAddress: (state, detailAddress) => {
      state.delivery = {
        ...state.delivery,
        detailAddress
      }
    },
    setCertification: (state, certification) => {
      state.memberCertification = {
        ...state.memberCertification,
        ...certification
      }
    }
  },
  getters: {
    useSafeNumber: (state) => state.useSafeNumber,

    getMobileNumber: (state) => () => {
      let { mobileNumber } = state
      if (mobileNumber === null) {
        mobileNumber = ''
      }
      return mobileNumber
    },
    getPayment: (state) => () => state.payment,
    getCheckedPaymentMethodName: (state) => () => state.payment.checkedMethodName,
    getCheckedPaymentMethodDescription: (state) => () => state.payment.checkedMethodDescription,
    getPrimaryPaymentMethodTypes: (state) => () => state.availablePaymentMethods.primaryMethodTypes,
    getShowPaymentMethod: (state) => () => state.showPaymentMethod,
    getDelivery: (state) => () => state.delivery,
    getDeliveryFeeDetail: (state) => () => state.deliveryFeeDetail,
    getDeliveryMemo: (state) => () => state.delivery.memo,
    getShopId: (state) => () => state.shopId,
    getBaeminShopNo: (state) => () => state.baeminShopNo,
    getProducts: (state) => () => state.products,
    getMemberCertification: (state) => () => state.memberCertification,
    isValidMobileNumber: (state) => () => {
      const number = state.mobileNumber
      if (number === null) {
        return false
      }
      const len = number.length
      return (len === 10 || len === 11) && number.match(/^01/)
    },
    isValidDetailAddress: (state) => () => {
      const { detailAddress } = state.delivery
      if (detailAddress === null) {
        return false
      }
      return detailAddress.trim().length > 0
    }
  },
  actions: {}
}

export default legacy
